import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import Tooltip from 'primevue/tooltip';
import Aura from "@primevue/themes/aura"
import axios from "axios";
import authService from './services/auth.js';
import { createPinia } from 'pinia'   // ADD THIS LINE

// In your main.js or app entry point
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.error and console.warn for critical issues
}
// Configure API base URL based on environment
const getApiBaseUrl = () => {
    // In development, call backend directly
    if (process.env.NODE_ENV === 'development') {
      return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
    }
    
    // In production, nginx proxies /api to backend
    return '';
  };
  
  axios.defaults.baseURL = getApiBaseUrl();

  // IMPORTANT: Add JWT token to all API requests
  axios.interceptors.request.use(
    async (config) => {
      try {
        const token = await authService.getCurrentToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.warn('Failed to get auth token:', error);
      }
      
      // Debug logging in development
      if (process.env.NODE_ENV === 'development') {
        console.log(`🚀 API: ${config.method?.toUpperCase()} ${config.url}`);
        if (config.headers.Authorization) {
          console.log('🔐 Request includes auth token');
        }
      }
      
      return config;
    },
    (error) => {
      console.error('❌ API Request Error:', error);
      return Promise.reject(error);
    }
  );

  // Handle 401 responses (token expired/invalid)
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        console.warn('🔐 Unauthorized - redirecting to login');
        
        // Sign out user and reload page to show login
        await authService.signOut();
        window.location.reload();
      }
      return Promise.reject(error);
    }
  );
  
  // Debug logging in development
  if (process.env.NODE_ENV === 'development') {
    console.log('🔧 Development Mode');
    console.log('📡 API Base URL:', axios.defaults.baseURL);
  }
  
const app = createApp(App);
const pinia = createPinia()          
app.use(pinia)                        //  (must be BEFORE app.use(store))
app.use(store);
app.use(router, axios);
app.use(PrimeVue, {
    theme: {
        preset: Aura
    }
});
app.directive('tooltip', Tooltip);

// Make authService globally available (optional)
app.config.globalProperties.$auth = authService;

app.mount("#app");